module.exports = __webpack_public_path__ + "static/img/icon-homeDefult.28ac9333.png";